import DOMPurify from 'dompurify';

export const getServicingType = (props: any) => {
  if (props.location.pathname.indexOf('/servicing/windows/') > -1) {
    return 'windows';
  } else if (props.location.pathname.indexOf('/servicing/proplus/') > -1) {
    return 'proplus';
  } else {
    return 'windows';
  }
};

export const getServicingVersionNumber = (props: any) => {
  if (props.location.pathname.indexOf('/servicing/windows/') > -1) {
    return props.location.pathname.split('/')[3];
  } else if (props.location.pathname.indexOf('/servicing/proplus/') > -1) {
    return props.location.pathname.split('/')[3];
  } else {
    return undefined;
  }
};

export const defaultWindowsServicingVersionNumber = '20h2';
export const defaultProPlusServicingVersionNumber = '1910';

export const endsWith = (s: string, target: string) => {
  return s.substr(-target.length) === target;
};

// export const isObject = (obj: any) => {
//   return obj !== null && typeof obj === 'object';
// };

export const compareDateTime = (a: undefined | Date, b: undefined | Date) => {
  if (a && b) {
    return a < b ? 1 : -1;
  } else {
    return 0;
  }
};




const defaultOptions = {
  ALLOWED_TAGS: [ 'div', 'br', 'b', 'i', 'u' ],
  ALLOWED_ATTR: []
};

export const sanitize = (dirty: string, options: any) => {

  const html = DOMPurify.sanitize(
    dirty, 
    { ...defaultOptions, ...options }
  );

  const htmlUnknown = html as unknown; // TODO: convert TrustedHTML to string properly

  return {
    __html: htmlUnknown as string
  };
};




export const wait = async (ms: number) => {
  return new Promise(resolve => {
    setTimeout(async () => {
      resolve(true);
    }, ms);
  });
};




export const asyncForEach = async <T>(array: T[], callback: (item: T, index: number, array: T[]) => Promise<void>) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};



export const defaultValue = <T>(developmentValue: T, value: T) => {
  console.log('defaultValue');
  if (process.env.NODE_ENV === 'development') {
    console.log('DEV');
    console.log(developmentValue);
    return developmentValue;
  } else {
    console.log('PROD');
    return value;
  }
};



export const isNumeric = (str: any) => {
  return !isNaN(str) && !isNaN(parseFloat(str));
};
